import React, { FC, useCallback } from 'react'
import FilterPills from './FilterPills'

const AdvancedSpecialtyFilter: FC<{
    specialty: string[]
    specialtyOption: string[]
    handleClick: (specialty: string[]) => void
}> = ({ handleClick, specialty, specialtyOption }) => {
    const handleSpecialtyFilterClick = useCallback(
        (spec: string) => () => {
            if (specialty.includes(spec)) {
                handleClick(specialty.filter((value) => value !== spec))
                return
            }

            handleClick([...specialty, spec])
        },
        [specialty, handleClick]
    )
    return (
        <>
            {specialtyOption.map((spec) => (
                <FilterPills
                    data-testid={`listingDialog_specialtyFilters_${spec}`}
                    buttonText={spec}
                    key={spec}
                    handleClick={handleSpecialtyFilterClick(spec)}
                    isActive={specialty.includes(spec)}
                />
            ))}
        </>
    )
}

export default AdvancedSpecialtyFilter
